<div class="dashboard-label">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" *ngFor="let menu of menus">
            <a class="nav-link" routerLinkActive="active" routerLink="{{menu.link}}" >{{menu.title}}</a>
        </li>
    </ul>
</div>
